import {Button, Spinner} from '@sail/ui';
import {defineMessages, FormattedMessage} from 'react-intl';

const messages = defineMessages({
  cancel: {
    id: 'conversations_ui.widget.requestACallTopBar.cancel',
    description: 'Button to cancel the request a call',
    defaultMessage: 'Cancel',
  },
  calling: {
    id: 'conversations_ui.widget.requestACallTopBar.calling',
    description: 'Button text when a call is in progress',
    defaultMessage: 'Calling',
  },
});

export const CancelButton = ({
  isLoading,
  isCalling,
  onCancel,
  screenshareRender = false,
}: {
  isLoading: boolean;
  isCalling: boolean;
  onCancel: () => void;
  screenshareRender?: boolean;
}) => {
  return screenshareRender ? (
    <Button
      data-testid="cancel-rac-button"
      size="small"
      onPress={onCancel}
      disabled={isCalling || isLoading}
      css={{flex: 1, gap: 'small', height: '28px'}}
    >
      {isLoading ? (
        <Spinner
          data-testid="loading-spinner"
          css={{
            width: 'fill',
            paddingX: 'small',
          }}
        />
      ) : (
        <FormattedMessage
          {...(isCalling ? messages.calling : messages.cancel)}
        />
      )}
    </Button>
  ) : (
    <Button
      data-testid="cancel-rac-button"
      size="small"
      css={{marginLeft: 'small'}}
      onPress={onCancel}
      disabled={isCalling || isLoading}
    >
      {isLoading ? (
        <Spinner
          data-testid="loading-spinner"
          css={{
            width: 'fill',
            paddingX: 'small',
          }}
        />
      ) : (
        <FormattedMessage
          {...(isCalling ? messages.calling : messages.cancel)}
        />
      )}
    </Button>
  );
};
